import React, { useState } from 'react';
import { db } from '../config/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { X, AlertCircle, CheckCircle } from 'lucide-react';

const ContactModal = ({ isOpen, onClose, prefillMessage = '' }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        colonia: '',
        interest: 'Vibe Coding',
        message: prefillMessage
    });
    const [status, setStatus] = useState('idle');

    // Update message when prefillMessage changes
    React.useEffect(() => {
        if (prefillMessage) {
            setFormData(prev => ({ ...prev, message: prefillMessage }));
        }
    }, [prefillMessage]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');

        try {
            await addDoc(collection(db, "i3_leads"), {
                ...formData,
                createdAt: serverTimestamp(),
                source: 'vibe_coding_modal'
            });
            setStatus('success');
        } catch (error) {
            console.error("Error writing document: ", error);
            setStatus('error');
        }
    };

    const handleClose = () => {
        setStatus('idle');
        setFormData({ name: '', email: '', phone: '', colonia: '', interest: 'Vibe Coding', message: '' });
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={handleClose}></div>

            {/* Modal */}
            <div className="relative bg-surface border border-zinc-800 rounded-2xl p-6 md:p-8 w-full max-w-md shadow-2xl">
                <button onClick={handleClose} className="absolute top-4 right-4 text-zinc-500 hover:text-white">
                    <X size={20} />
                </button>

                <h3 className="text-xl font-bold text-white mb-6">Contáctanos</h3>

                {status === 'success' ? (
                    <div className="bg-green-500/10 border border-green-500 text-green-500 p-4 rounded-lg flex items-center gap-3">
                        <CheckCircle size={24} />
                        <div>
                            <p className="font-bold">¡Mensaje Enviado!</p>
                            <p className="text-sm">Te contactaremos pronto.</p>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-2 gap-4">
                            <input
                                name="name" value={formData.name} onChange={handleChange} required
                                type="text" placeholder="Nombre"
                                className="bg-background border border-zinc-700 text-white p-3 rounded focus:border-primary focus:outline-none text-sm w-full"
                            />
                            <input
                                name="email" value={formData.email} onChange={handleChange} required
                                type="email" placeholder="Email"
                                className="bg-background border border-zinc-700 text-white p-3 rounded focus:border-primary focus:outline-none text-sm w-full"
                            />
                        </div>
                        <input
                            name="phone" value={formData.phone} onChange={handleChange} required
                            type="tel" placeholder="WhatsApp"
                            className="w-full bg-background border border-zinc-700 text-white p-3 rounded focus:border-primary focus:outline-none text-sm"
                        />
                        <select
                            name="colonia" value={formData.colonia} onChange={handleChange} required
                            className="w-full bg-background border border-zinc-700 text-zinc-400 p-3 rounded focus:border-primary focus:outline-none text-sm"
                        >
                            <option value="">Colonia...</option>
                            <option value="Agricola Oriental">Agrícola Oriental</option>
                            <option value="Pantitlan">Pantitlán</option>
                            <option value="Granjas Mexico">Granjas México</option>
                            <option value="Ramos Millan">Ramos Millán</option>
                            <option value="Santa Anita">Santa Anita</option>
                            <option value="Otra">Otra</option>
                        </select>

                        <textarea
                            name="message" value={formData.message} onChange={handleChange}
                            rows="3" placeholder="Mensaje..."
                            className="w-full bg-background border border-zinc-700 text-white p-3 rounded focus:border-primary focus:outline-none text-sm"
                        ></textarea>

                        <button
                            type="submit"
                            disabled={status === 'loading'}
                            className="w-full bg-primary text-black font-bold py-3 rounded hover:opacity-90 transition-opacity disabled:opacity-50"
                        >
                            {status === 'loading' ? 'ENVIANDO...' : 'ENVIAR'}
                        </button>

                        {status === 'error' && (
                            <p className="text-red-500 text-xs flex items-center gap-1">
                                <AlertCircle size={14} /> Error al enviar. Intenta de nuevo.
                            </p>
                        )}
                    </form>
                )}
            </div>
        </div>
    );
};

export default ContactModal;
